import React from 'react'
import { colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import FAQContent from './FAQContent'
import Tip from '../../../../components/tip/Tip'

export default function HelpWithThisStep({
  personId,
  currentStep,
  handleGoToNextRecordAndResetStep,
  hasImagePermission,
}) {
  const [t] = useTranslation()
  return (
    <Tip
      overline={' '}
      primaryText={
        <span style={{ color: colors.blue60 }}>
          <strong>{t('family-review.step2.help-with-this-step', 'Help with this step')}</strong>
        </span>
      }
      listPrimaryText={
        <FAQContent
          personId={personId}
          currentStep={currentStep}
          handleGoToNextRecordAndResetStep={handleGoToNextRecordAndResetStep}
          hasImagePermission={hasImagePermission}
        />
      }
    />
  )
}
